import React from "react";
import Header from "../../../common/header";
import Box from "@mui/material/Box";
import {Button, Grid, Dialog, DialogActions, DialogContent, DialogTitle, TextField} from "@mui/material";

import Header2 from "../../../common/header/Header2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {ReactComponent as SearchWhiteIcon} from "./profile_icon/search-white-icon.svg";
import {ReactComponent as NotificationIcon} from "./profile_icon/notification-icon.svg";
import {useEffect, useCallback} from "react";
import UserAvatar from "../../userAvatar";
import {ReactComponent as ProfileIcon} from "./profile_icon/profile-icon.svg";
import "./profile.css";
import TabHook from "../../../common/hooks/TabHook";
import {BottomNavigation, BottomNavigationAction, IconButton, useMediaQuery} from "@mui/material";
import {getAlertCountAPI, getTop7DayPerformerAPI, updateAccount} from "../../../apihelper/profile";
import {getNormalUserData, getUserReward} from "../../../apihelper/portfolio";
import TransactionCard2 from "../reward_trasaction_history/TransactionCard2";
import json2mq from "json2mq";
import MyPortfolioTable from "./tables/MyPortfolioTable";
import {Day7SummaryTable} from "./tables/Day7SummaryTable";
import CryptoWatchlist from "./tables/CryptoWatchlist";
import MyPortfolioWatchlist from "./tables/MyPortfolioWatchlist";
import MyCryptoWatchlist from "./tables/MyPortfolioWatchlist";

import {Helmet} from "react-helmet";
import {drawerWidth} from "../../../common/constants";
import {tabLink} from "../../../common/constant/tablink";
import {useState} from "react";
import BottomTab from "../../../common/hooks/BottomTab";
import Snackbar from "@mui/material/Snackbar";


const modalOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};

const modalContentStyle = {
        minWidth: "380px",
        padding: "10px",
        background: "linear-gradient(90deg, #9AEB37 0%, #FFF73F 100%)",
        borderRadius: "24px",
        textAlign: "center",
        paddingTop: "0px",
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
        minHeight:  "325px",
};

const Account = () => {
    const navigate = useNavigate();
    const [rewards, setRewards] = React.useState(null);
    const [error, setError] = React.useState(false);
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
      const [snackbarOpen, setSnackbarOpen] = React.useState(false);
        const [snackbarMessage, setSnackbarMessage] = React.useState("Loading...");
    const handleBackClick = () => navigate(-1);

      const handleButtonClick = () => {
        setIsDialogOpen(true);
    };

      const handleNameChange = (e) => {
        setFullName(e.target.value);
    };
   

    const [snackbaropen, setSnackbaropen] = React.useState(false);
    const [severity, setSeverity] = React.useState("info");
    const [snackbarmessage, setSnackbarmessage] = React.useState("Loading...");
    const [fullName, setFullName] = React.useState("");
    const [profilePhoto, setProfilePhoto] = React.useState();
    const [walletAddress, setWalletAddress] = React.useState("");
    const [copied, setCopied] = React.useState(false);
    const [youtubeLink, setYoutubeLink] = React.useState("");
    const [twitterLink, setTwitterLink] = React.useState("");
    const [telegramLink, setTelegramLink] = React.useState("");
    const [instagramLink, setInstagramLink] = React.useState("");

    const [isEditingTwitter, setIsEditingTwitter] = React.useState(false);
    const [isEditing, setIsEditing] = React.useState(false);
    const [description, setDescription] = React.useState("");
    const [isSaved, setIsSaved] = React.useState(false);
    const [userReward, setUserReward] = React.useState({});
    const [isDialogOpen, setIsDialogOpen] = React.useState(false);
    const [errorReward, setErrorReward] = React.useState(false);

    const [unreadAlerts, setUnreadAlerts] = React.useState(0);
    const [top7DayPerformer, setTop7DayPerformer] = React.useState([]);

    const location = useLocation();
    const loc = location.pathname;

    const mediaQueryVar = useMediaQuery(
        json2mq({
            minWidth: 900,
        })
    );
    const headerTabOptions = [
        {
            id: 1,
            text: "Go To Home Page",
            route: "/",
            icon: "home-icon.svg",
            color: "#FFB45C",
        },
        {
            id: 2,
            text: "Crypto Screener",
            route: "/crypto-screener",
            icon: "search-icon.svg",
            color: "#D2FD8B",
        },
        {
            id: 3,
            text: "Price Predictions",
            route: "/crypto-predictions",
            icon: "prediction-page-icon.svg",
            color: "#FFE144",
        },
        {
            id: 4,
            text: "Audit My Portfolio",
            route: userData ? "/my-portfolio/detailed-portfolio-analysis" : "/audit-my-portfolio",
            icon: "audit-portfolio-icon.svg",
            color: "#48CEFF",
        },
    ];

    const handleSaveClick = () => {
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        const user_id = userData.user_id;
        const token = userData.token;

        updateAccount({
            user_id: user_id,
            fullName,
            profilePhoto,
            about: description,
            youtube: youtubeLink,
            twitter: twitterLink,
            telegram: telegramLink,
            instagram: instagramLink,
            wallet_address: walletAddress,
            token: token,
        }).then((res) => {
            if (res.code === "200") {
                setFullName(res.data.full_name);
                setDescription(res.data.description);
                setTwitterLink(res.data.twitter_link);
                setProfilePhoto(res.data.photo);
                setWalletAddress(res.data.wallet_address);
            } else {
                alert(res.message);
            }
        });
    };

    const handleTwitterChange = (e) => {
        setTwitterLink(e.target.value);
    };

    const handleEditClick = () => {
        setIsEditing(true);
    };
    const handleSave = () => {
        if (walletAddress) {
            const user_id = userData.user_id;
            const token = userData.token;

            updateAccount({
                user_id: user_id,
                fullName,
                profilePhoto,
                about: description,
                youtube: youtubeLink,
                twitter: twitterLink,
                telegram: telegramLink,
                instagram: instagramLink,
                wallet_address: walletAddress,
                token: token,
            }).then((res) => {
                if (res.code === "200") {
                    userData.full_name = fullName;
                    userData.wallet_address = walletAddress;

                    setFullName(res.data.full_name);
                    setDescription(res.data.description);
                    setTwitterLink(res.data.twitter_link);
                    setProfilePhoto(res.data.photo);
                    setWalletAddress(res.data.wallet_address);
                } else {
                    alert(res.message);
                }
            });
            setIsSaved(true);
        }
    };
    const handlePhotoChange = (e) => {
        const file = e.target.files[0];
        setProfilePhoto(file);
    };
    const handleDialogClose = () => {
        setIsDialogOpen(false);
    };
    const handleInputChange = (e) => {
        setWalletAddress(e.target.value);
        setIsSaved(false);
    };
    const generateReferralLink = () => {
        const formattedFullName = fullName.replace(/\s+/g, "-");
        return `https://investing.crowdwisdom.live/signUp?ref=${formattedFullName}`;
    };
    const handleButtonSaveClick = () => {
        setSnackbaropen(true);
        setSeverity("info");
        setSnackbarmessage("Loading...");
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        const user_id = userData?.user_id || "";
        const token = userData.token;
        const about = description;
        const wallet_address = walletAddress;
        const twitter = twitterLink;
        updateAccount({user_id, fullName, profilePhoto, token, about, wallet_address, twitter}).then((res) => {
            if (res.code === "200") {
                setSnackbarmessage(res.message);
                setFullName(res.data.full_name);
                setDescription(res.data.description);
                setTwitterLink(res.data.twitter_link);
                setProfilePhoto(res.data.photo);
                setWalletAddress(res.data.wallet_address);
                localStorage.setItem("cw_portfolio_user", JSON.stringify(userData));
            } else {
                setSeverity("error");
                setSnackbarmessage(res.message);
            }
        });

        handleDialogClose();
    };
    const handleTwitterEditClick = (e) => {
        e.preventDefault();
        setIsEditingTwitter(true);
    };
    const handleDescriptionChange = (e) => {
        setDescription(e.target.value);
    };
    const handleTwitterSaveClick = (e) => {
        e.preventDefault();
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        const user_id = userData.user_id;
        const token = userData.token;

        updateAccount({
            user_id: user_id,
            fullName,
            about: description,
            profilePhoto,
            youtube: youtubeLink,
            twitter: twitterLink,
            telegram: telegramLink,
            instagram: instagramLink,
            wallet_address: walletAddress,
            token: token,
        }).then((res) => {
            if (res.code === "200") {
                setFullName(res.data.full_name);
                setDescription(res.data.description);
                setTwitterLink(res.data.twitter_link);
                setProfilePhoto(res.data.photo);
                setWalletAddress(res.data.wallet_address);
            } else {
                alert(res.message);
            }
        });
    };

    const fetchUserRewards = async () => {
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        try {
            const data = await getUserReward(userData);
            setErrorReward(false);
            setUserReward(data);
            setRewards(data.withdraw_rewards);
        } catch (error) {
            errorReward(true);
            console.error("Error fetching rewards:", error);
        }
    };

    React.useEffect(() => {
        const userId = userData?.user_id || null;

        const fetchPerformer = async () => {
            const response = await getTop7DayPerformerAPI(userData);
            setTop7DayPerformer(response.data);
        };

        fetchPerformer();
    }, []);

    React.useEffect(() => {
        const userId = userData?.user_id || null;

        const fetchAlerts = async () => {
            const response = await getAlertCountAPI(userData?.user_id);
            if (response?.unread_notifications) {
                setUnreadAlerts(response?.unread_notifications);
            }
        };

        fetchAlerts();
    }, []);

    React.useEffect(() => {
        const fetchData = async () => {
            try {
                const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
                if (!userData) {
                    throw new Error("No user data found in local storage");
                }

                const user_idValue = userData.user_id;
                const user_token = userData.token;
                const userRes = await getNormalUserData({
                    user_id: user_idValue,
                    Token: user_token,
                });

                if (userRes.code === "200") {
                    fetchUserRewards();
                    const userData = userRes.data[0];
                    setFullName(userRes.data[0].full_name);
                    setDescription(userRes.data[0].description);
                    setTwitterLink(userRes.data[0].twitter_link);
                    setProfilePhoto(userRes.data[0].photo);
                    setWalletAddress(userRes.data[0].wallet_address);
                } else {
                    console.error(userRes.message);
                }
            } catch (error) {
                console.error("Error fetching data: ", error);
            }
        };
        fetchData();
    }, []);

    React.useEffect(() => {
        const fetchRewards = async () => {
            try {
                const response = await fetch("/api/user/rewards");
                const data = await response.json();
                console.log("rewards data: ",data);
                setRewards(data.rewards);
            } catch (error) {
                setError(true);
            }
        };
        fetchRewards();
    }, []);


    

    const [path, setPath] = React.useState("/");

    React.useEffect(() => {
        if (typeof window !== "undefined") {
            setPath(window.location.pathname);
        }
    }, []);
    const [mobileOpen, setMobileOpen] = React.useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    // const profileTabList = [
    //     {
    //         title: (
    //             <div className="profile-tab-div d-flex align-items-center">
    //                 <img
    //                     src={"/images/profile_image/account_image/gallery-icon.svg"}
    //                     alt="Profile Icon"
    //                     className="profile-tab-icon"
    //                 />
    //                 <span style={{whiteSpace: "nowrap"}}>{mediaQueryVar ? "My Profile" : "Profile"}</span>
    //             </div>
    //         ),
    //         url: "/account",
    //     },
    //     {
    //         title: (
    //             <div className="profile-tab-div">
    //                 <img
    //                     src={"/images/profile_image/account_image/invest-icon.svg"}
    //                     alt="Profile Icon"
    //                     className="profile-tab-icon"
    //                 />
    //                 <span style={{whiteSpace: "nowrap"}}>{mediaQueryVar ? "Invest In Presale" : "Presale"}</span>
    //             </div>
    //         ),
    //         url: "/pre-sale",
    //     },
    //     {
    //         title: (
    //             <div className="profile-tab-div">
    //                 <img
    //                     src={"/images/profile_image/account_image/search-white-icon.svg"}
    //                     alt="Profile Icon"
    //                     className="profile-tab-icon"
    //                     style={{marginLeft: "-8px"}}
    //                 />
    //                 <span style={{whiteSpace: "nowrap"}}>Farm $WISD</span>
    //             </div>
    //         ),
    //         url: "/reward-transaction-history",
    //     },
    // ];

    const [loading, setLoading] = useState(true);
    const SkeletonLoader = () => (
        <>
            {Array.from({length: 6}).map((_, index) => (
                <tr
                    key={index}
                    style={{
                        background: "#fff",
                        border: "1px solid #1877F2",
                        borderRadius: "10px",
                        marginBottom: "10px",
                        padding: "6px",
                        height: "60px",
                    }}
                >
                    {Array.from({length: 6}).map((_, idx) => (
                        <td
                            key={idx}
                            style={{
                                padding: "12px",
                                textAlign: "center",
                                fontSize: "14px",
                                border: "1px solid #1877F2",
                                borderRadius: idx === 0 ? "20px 0 0 20px" : idx === 5 ? "0 20px 20px 0" : "0",
                                borderLeft: idx === 0 ? "none" : "",
                                borderRight: idx === 4 ? "none" : "",
                            }}
                        >
                            <div className="skeleton-box" />
                        </td>
                    ))}
                </tr>
            ))}
        </>
    );

    const [cryptoData, setCryptoData] = useState([]);
    const {filter} = "";

    useEffect(() => {
        const url = `https://crowdwisdom.live/wp-json/api/v1/hiddenGems`;

        fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        })
        .then((response) => response.json())
        .then((data) => {
            console.log(data);
            setCryptoData(Array.isArray(data) ? data : []);
            setLoading(false);
        })
        .catch((error) => {
            console.error("Error fetching data:", error);
            setLoading(false);
        });
    }, []);

    const TopNavigationDesktop = ({unreadAlerts}) => {
        const isActive = (href) => path === href;

        const topTabStyle = (active) => ({
            display: "flex",
            alignItems: "center",
            padding: active ? "5px 13px" : "2px 13px",
            borderRadius: "999px",
            backgroundColor: active ? "#ffffff" : "transparent",
            color: active ? "#1877F2" : "#ffffff",
            fontWeight: active ? "600" : "500",
            fontSize: "16px",
            cursor: "pointer",
            border: active ? "2px solid #ffffff" : "none",
        });

        const iconFilter = (active) =>
            active
                ? "invert(29%) sepia(98%) saturate(1502%) hue-rotate(189deg) brightness(100%) contrast(97%)"
                : "brightness(0) invert(1)";

        return (
            <div style={{padding: "20px", background: "#ffffff", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"}}>
                {/* Top Navigation */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: "0 auto",
                    }}
                >
                    {/* Left Tabs */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            backgroundColor: "#1877F2",
                            padding: "5px 5px",
                            borderRadius: "50px",
                        }}
                    >
                        {[tabLink["profile"], tabLink["presale"], tabLink["reward_history"]].map((tab, index) => (
                            <Link to={tab.href} style={{textDecoration: "none", minWidth: "130px"}}>
                                <div style={topTabStyle(isActive(tab.href))}>
                                    <img
                                        src={window.constants.asset_path + tab.icon}
                                        alt="home"
                                        style={{
                                            marginRight: "6px",
                                            filter: iconFilter(isActive(tab.href)),
                                            width: tab.icon_width || "25px",
                                        }}
                                    />
                                    {!mediaQueryVar ? tab.mobile_name : tab.name}
                                </div>
                            </Link>
                        ))}
                    </div>

                    {/* Bottom Tabs */}
                    <BottomTab
                        tabs={[
                            tabLink["subscription"],
                            userData ? tabLink["my_portfolio"] : tabLink["portfolio_audit"],
                            tabLink["presale"],
                        ]}
                    />
                    {/* Notification Bell */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            gap: "5px",
                            marginRight: "15px",
                        }}
                    >
                        {/* Notification Bell */}
                        <div
                            onClick={() => (window.location.href = "/alerts")}
                            style={{position: "relative", cursor: "pointer"}}
                        >
                            <NotificationIcon className="notification-icon fa-2x" />
                            {/* Desktop */}
                        <div
                                style={{
                                    position: "absolute",
                                    top: "-6px",
                                    right: "2px",
                                    backgroundColor: "#c0392b",
                                    minWidth: unreadAlerts < 100 ? "20px": "27px",
                                    height: unreadAlerts < 100 ? "20px": "27px",
                                    borderRadius: "50%",
                                    fontSize: "11px",
                                    color: "#fff",
                                    textAlign: "center",
                                    lineHeight: "20px",
                                    fontWeight: "bold",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0 4px",
                                }}
                                >
                                {unreadAlerts < 100 ? unreadAlerts : "99+"}
                                </div>
                        </div>

                        <UserAvatar />
                    </div>
                </div>
            </div>
        );
    };
    const bottomNavigationMobile = [
        tabLink["subscription"],
        userData ? tabLink["my_portfolio"] : tabLink["portfolio_audit"],
        tabLink["screener"],
    ];
    const topNavigationMobile = [tabLink["profile"], tabLink["reward_history"]];


    //Staking Related Code
  const [walletModalOpen, setWalletModalOpen] = useState(false);
  const [stakeFormOpen, setStakeFormOpen] = useState(false);
  const [isWalletAvailable, setIsWalletAvailable] = useState(false);
  const [walletInput, setWalletInput] = useState("");
  const [userStakedAmounts, setUserStakedAmounts] = useState({
        months3: 0,
        months6: 0,
        months12: 0
        });

  const [stakingAmounts, setStakingAmounts] = useState({
    months3: "",
    months6: "",
    months12: "",
  });

   useEffect(() => {
  if (stakeFormOpen) {
    const fetchStakedData = async () => {
      try {
        const userId = userData.user_id; // Replace this with the actual user ID, or fetch from state/auth
        const response = await fetch(`https://crowdwisdom.live/wp-json/api/v1/user-stakes/${userId}`);

        if (!response.ok) {
          throw new Error('Failed to fetch stake data');
        }

        const result = await response.json();

        setUserStakedAmounts({
          months3: result.months3 || 0,
          months6: result.months6 || 0,
          months12: result.months12 || 0
        });
      } catch (error) {
        console.error('Error fetching stake data:', error);
      }
    };

    fetchStakedData();
  }
}, [stakeFormOpen]);



  // Check wallet and open appropriate modal
  const handleStakeClick = useCallback(async () => {
    if (!userData) return;
    const user = { user_id: userData.user_id, Token: userData.token };
    try {
      console.log("User Profile: ",walletAddress);
     
      if (walletAddress) {
         console.log("Entered into If block");
        setIsWalletAvailable(true);
        setWalletAddress(walletAddress);
        setStakeFormOpen(true);
      } else {
        console.log("Entered into else block");
        setIsWalletAvailable(false);
        setWalletModalOpen(true);
      }
    } catch (error) {
      console.error("Error fetching wallet details:", error);
    }
  }, [userData]);

  // Submit wallet address
  const handleWalletSave = async () => {
    if (!walletInput) return;
    try {
      if (walletInput) {
            const user_id = userData.user_id;
            const token = userData.token;

            updateAccount({
                user_id: user_id,
                fullName,
                profilePhoto,
                about: description,
                youtube: youtubeLink,
                twitter: twitterLink,
                telegram: telegramLink,
                instagram: instagramLink,
                wallet_address: walletInput,
                token: token,
            }).then((res) => {
                if (res.code === "200") {
                    userData.full_name = fullName;
                    userData.wallet_address = walletInput;
                    console.log("wallet data:", res);

                    setFullName(res.data.full_name);
                    setDescription(res.data.description);
                    setTwitterLink(res.data.twitter_link);
                    setProfilePhoto(res.data.photo);
                    setWalletAddress(res.data.wallet_address);
                } else {
                    alert(res.message);
                }
            });
            setIsSaved(true);
        }
      setWalletAddress(walletInput);
      setIsWalletAvailable(true);
      setWalletModalOpen(false);
      setStakeFormOpen(true);
    } catch (error) {
      console.error("Error saving wallet address:", error);
    }
  };

  // Handle staking form changes
  const handleAmountChange = (e) => {
    const { name, value } = e.target;
    setStakingAmounts(prev => ({ ...prev, [name]: value }));
  };

  // Submit staking
const handleStakeSubmit = async () => {
  const entries = [];
  if (stakingAmounts.months3) entries.push({ period_months: 3, amount: parseFloat(stakingAmounts.months3) });
  if (stakingAmounts.months6) entries.push({ period_months: 6, amount: parseFloat(stakingAmounts.months6) });
  if (stakingAmounts.months12) entries.push({ period_months: 12, amount: parseFloat(stakingAmounts.months12) });

  if (entries.length === 0) {
    alert("Please enter at least one staking amount.");
    return;
  }

  // ✅ Calculate total stake amount
  const totalStake = entries.reduce((sum, entry) => sum + entry.amount, 0);

  // ✅ Check against available rewards balance
  if (totalStake > parseFloat(rewards)) {
    alert(`You are trying to stake ${totalStake} WISD, but your available balance is only ${rewards} WISD.`);
    return;
  }

  try {
    const response = await fetch('https://crowdwisdom.live/wp-json/api/v1/submitStake', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        user_id: userData.user_id,
        wallet_address: walletAddress,
        stakes: entries
      })
    });

    const result = await response.json();
    console.log('Stake response:', result);

    if (result.success) {
      alert("Staking submitted successfully!");
      setStakeFormOpen(false);
       window.location.reload(); 
      
      // Optionally refresh rewards/profile here
    } else {
      alert("Staking submission failed.");
    }
  } catch (error) {
    console.error("Error submitting staking:", error);
    alert("An error occurred while submitting your stake.");
  }
};




    return (
        <>
      

            <div
                className="profile-main"
                style={{width: "100%", overflowX: "hidden", marginBottom: mediaQueryVar ? "" : "40px"}}
            >
      {/* Wallet Address Modal */}
      {walletModalOpen && (
        <div style={modalOverlayStyle} onClick={() => setWalletModalOpen(false)}>
          <div style={modalContentStyle} onClick={(e) => e.stopPropagation()}>
            <h4 style={{fontSize:"20px", fontWeight:"bold", textAlign:"center", marginTop:"25px",marginBottom:"15px"}}>Enter Your Solana Wallet Address</h4>
             <div style={{textAlign: "center", fontSize: "16px", color: "#333"}}>
                                        ⚠️ <b>Wallet Address Not Found</b> <br />
                                        <span style={{fontSize: "14px", color: "#555"}}>
                                            You have not added a wallet address yet. Please set one to proceed.
                                        </span>
                                        <br />
                                        <br />
                                        🔒{" "}
                                        <i>Ensure that you enter a valid wallet address to receive rewards securely.</i>
                                    </div>
            <input
              type="text"
              value={walletInput}
              onChange={(e) => setWalletInput(e.target.value)}
              placeholder="Wallet Address"
              style={{ width: "90%", padding: "8px", background:"white", borderRadius:"15px", border:"none", margin:"5px auto", color:"black" }}
            />
            <button onClick={handleWalletSave} style={{ marginRight: "20px", background:"#1877F2", padding:"5px 15px",borderRadius:"12px", border:"none",marginTop: "20px", }}>Save Address</button>
            <button style={{background:"#1877F2", padding:"5px 15px",borderRadius:"12px", border:"none",marginTop: "20px"}} onClick={() => setWalletModalOpen(false)}>Cancel</button>
          </div>
        </div>
      )}

      {/* Staking Form Modal */}
      {stakeFormOpen && (
        <div style={modalOverlayStyle} onClick={() => setStakeFormOpen(false)}>
          <div style={modalContentStyle} onClick={(e) => e.stopPropagation()}>
            <h3 style={{fontSize:"20px", fontWeight:"bold", textAlign:"center", marginTop:"25px",marginBottom:"15px"}}>Stake Your WISD Tokens</h3>
            <p style={{color:"green", fontWeight:"bold"}}>Your Balance: {rewards} WISD</p>

            <div style={{ marginBottom: "20px" }}>
            <label style={{ fontWeight: "bold" }}>3 months @2% per month</label>
            <input
                type="number"
                name="months3"
                value={stakingAmounts.months3}
                onChange={handleAmountChange}
                placeholder="Amount"
                style={{
                width: "100%",
                padding: "8px",
                marginTop: "5px",
                background: "white",
                borderRadius: "15px",
                border: "none",
                margin: "2px auto",
                color: "black"
                }}
            />
             <p style={{ margin: "0px 0", color: "#555" }}>
                Already Staked: <strong style={{color:"green"}}>{userStakedAmounts.months3} WISD</strong>
            </p>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label style={{fontWeight:"bold"}}>6 months @4% per month</label>
              <input
                type="number"
                name="months6"
                value={stakingAmounts.months6}
                onChange={handleAmountChange}
                placeholder="Amount"
                style={{ width: "100%", padding: "8px", marginTop: "5px",background:"white", borderRadius:"15px", border:"none", margin:"2px auto", color:"black" }}
              />
              <p style={{ margin: "0px 0", color: "#555" }}>
                Already Staked: <strong style={{color:"green"}}>{userStakedAmounts.months6} WISD</strong>
            </p>
            </div>
            <div style={{ marginBottom: "20px" }}>
              <label style={{fontWeight:"bold"}}>12 months @5% per month</label>
              <input
                type="number"
                name="months12"
                value={stakingAmounts.months12}
                onChange={handleAmountChange}
                placeholder="Amount"
                style={{ width: "100%", padding: "8px", marginTop: "5px",background:"white", borderRadius:"15px", border:"none", margin:"2px auto", color:"black" }}
              />
              <p style={{ margin: "0px 0", color: "#555" }}>
                Already Staked: <strong style={{color:"green"}}>{userStakedAmounts.months12} WISD</strong>
            </p>
            </div>
            <button onClick={handleStakeSubmit} style={{ marginRight: "10px",background:"#1877F2", padding:"5px 15px",borderRadius:"12px", border:"none",color:"#fff" }}>Submit Stake</button>
            <button style={{background:"#1877F2", padding:"5px 15px",borderRadius:"12px", border:"none",color:"#fff"}} onClick={() => setStakeFormOpen(false)}>Cancel</button>
          </div>
        </div>
      )}
                <div className="d-flex row  w-100 m-0">
                    <Helmet>
                        <title>Profile</title>
                    </Helmet>

                   
                    {/* Side Bar */}
                    {/* {mediaQueryVar ? null : ( */}
                    <Header2 bottomNavigationMobile={bottomNavigationMobile} topNavigationMobile={topNavigationMobile}>
                        <div
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0, // aligns it to the right of the sidebar
                                width: "100%", // takes full width minus sidebar
                                backgroundColor: "#ffffff",
                                zIndex: 1000,
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                height: "100px",
                                padding: "10px",
                            }}
                        >
                            {/* <TopNavigationMobile unreadAlerts={unreadAlerts} /> */}
                        </div>
                    </Header2>
                    {/* )} */}

                    <div className="profile-section col" style={{maxWidth: "100%"}}>
                        <div className="profile-container  profile-container-lg">
                            
                            <div
                                className="is-desktop"
                                style={{
                                    position: "fixed",
                                    top: 0,
                                    left: drawerWidth, // aligns it to the right of the sidebar
                                    width: `calc(100% - ${drawerWidth}px)`, // takes full width minus sidebar
                                    backgroundColor: "#ffffff",
                                    zIndex: 1000,
                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                   
                                }}
                            >
                                <TopNavigationDesktop unreadAlerts={unreadAlerts} />
                            </div>
                            {/* Profile tabs */}
                            {mediaQueryVar ? (
                                <div style={{marginTop: "100px"}}></div>
                            ) : (
                                <div style={{marginTop: "150px"}}></div>
                            )}



                             <Box
                                                                    style={{
                                                                        backgroundColor: "white",
                                                                        marginTop: "0px",
                                                                        marginLeft: "-20px",
                                                                        marginRight: "18px",
                                                                        padding: "15px 25px",
                                                                        borderRadius: "10px",
                                                                        width: "100%",
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            gap: "20px",
                                                                            display: "inline-flex",
                                                                            padding: "5px 2px",
                                                                            borderRadius: "38px",
                                                                            paddingRight: "20px",
                                                                            marginBottom: "0px",
                                                                        }}
                                                                    >
                                                                        {profilePhoto ? (
                                                                            <img
                                                                                src={profilePhoto}
                                                                                alt="profile_pic"
                                                                                style={{
                                                                                    width: "42px",
                                                                                    height: "42px",
                                                                                    position: "relative",
                                                                                    borderRadius: "33px",
                                                                                    border: "2px black solid",
                                                                                }}
                                                                            ></img>
                                                                        ) : (
                                                                            <img
                                                                                src="/images/avtar.jpeg"
                                                                                alt="profile_pic"
                                                                                style={{
                                                                                    width: "42px",
                                                                                    height: "42px",
                                                                                    position: "relative",
                                                                                    borderRadius: "33px",
                                                                                    border: "2px black solid",
                                                                                }}
                                                                            ></img>
                                                                        )}
                            
                                                                        <div
                                                                            style={{
                                                                                justifyContent: "center",
                                                                                alignItems: "center",
                                                                                gap: "5px",
                                                                                display: "flex",
                                                                            }}
                                                                        >
                                                                            <div
                                                                                style={{
                                                                                    color: "black",
                                                                                    fontSize: "20px",
                                                                                    fontWeight: "600",
                                                                                    marginLeft: "-5px",
                                                                                    fontFamily: "Satoshi, sans-serif",
                                                                                    wordWrap: "break-word",
                                                                                }}
                                                                            >
                                                                                {fullName ? (
                                                                                    fullName
                                                                                ) : (
                                                                                    <div
                                                                                        style={{
                                                                                            width: "25vw",
                                                                                            height: "24px",
                                                                                            backgroundColor: "#E0E0E0",
                                                                                            borderRadius: "4px",
                                                                                            animation: "skeleton-loading 1.5s infinite linear",
                                                                                        }}
                                                                                    ></div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <Button
                                                                        variant="outlined"
                                                                        style={{
                                                                            backgroundColor: "white",
                                                                            textTransform: "none",
                                                                            fontFamily: "Satoshi, sans-serif",
                                                                            fontSize: "14px",
                                                                            fontWeight: "600",
                                                                            height: mediaQueryVar === false ? "35px" : "",
                                                                            borderColor: "white",
                                                                            padding: "0px",
                                                                            marginTop: "-40px",
                                                                        }}
                                                                        onClick={handleButtonClick}
                                                                    >
                                                                        <img
                                                                            src="/images/edit-new.svg"
                                                                            style={{
                                                                                marginRight: "0px",
                                                                                height: "24px",
                                                                                width: "24px",
                                                                                marginLeft: "30px",
                                                                            }}
                                                                        />
                                                                    </Button>
                            
                                                                    <Dialog open={isDialogOpen} onClose={handleDialogClose}>
                                                                        <DialogTitle>Edit Profile</DialogTitle>
                                                                        <DialogContent>
                                                                            <TextField
                                                                                autoFocus
                                                                                margin="dense"
                                                                                label="Full Name"
                                                                                type="text"
                                                                                fullWidth
                                                                                value={fullName}
                                                                                onChange={handleNameChange}
                                                                            />
                                                                            <input
                                                                                accept="image/*"
                                                                                type="file"
                                                                                onChange={handlePhotoChange}
                                                                                style={{display: "none"}}
                                                                                id="profile-photo-upload"
                                                                            />
                                                                            <label htmlFor="profile-photo-upload">
                                                                                <Button variant="contained" color="primary" component="span">
                                                                                    Upload Photo
                                                                                </Button>
                                                                            </label>
                                                                        </DialogContent>
                                                                        <DialogActions>
                                                                            <Button onClick={handleDialogClose} color="primary">
                                                                                Cancel
                                                                            </Button>
                                                                            <Button onClick={handleButtonSaveClick} color="primary">
                                                                                Save
                                                                            </Button>
                                                                        </DialogActions>
                                                                    </Dialog>
                            
                                                                    <Snackbar
                                                                        open={snackbarOpen}
                                                                        autoHideDuration={6000}
                                                                        onClose={() => setSnackbarOpen(false)}
                                                                        message={snackbarMessage}
                                                                        severity={severity}
                                                                    />
                                                                </Box>







                            <div
                                className="input-container row mt-4 order-2  order-md-2 "
                                style={{marginRight: mediaQueryVar ? "15px" : ""}}
                            >
                                <div className="address-input col-12 col-md-6 mb-3">
                                    <input
                                        style={{
                                            paddingRight: "58px",
                                        }}
                                        type="text"
                                        id="userInput"
                                        placeholder="Enter Your Solana Wallet Address"
                                        value={walletAddress}
                                        onChange={handleInputChange}
                                    />
                                    <button onClick={handleSave}>Save</button>
                                </div>
                                <div className="address-input col-12 col-md-6 mb-3">
                                    <input
                                        style={{
                                            paddingRight: copied ? "70px" : "63px",
                                        }}
                                        type="text"
                                        placeholder="Your Referral Link"
                                        value={generateReferralLink()}
                                        readOnly
                                        onFocus={(e) => (e.target.style.boxShadow = "0px 4px 10px rgba(0, 0, 0, 0.2)")}
                                        onBlur={(e) => (e.target.style.boxShadow = "0px 2px 6px rgba(0, 0, 0, 0.1)")}
                                    />
                                    <button
                                        onClick={() => {
                                            navigator.clipboard.writeText(generateReferralLink());
                                            setCopied(true);
                                            setTimeout(() => setCopied(false), 2000);
                                        }}
                                        onMouseEnter={(e) => (e.target.style.transform = "scale(1.1)")}
                                        onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
                                    >
                                        {copied ? "Copied!" : "Copy"}
                                    </button>
                                </div>
                                <div className="address-input col-12 col-md-6 mb-3">
                                    <input
                                        style={{
                                            paddingRight: "58px",
                                        }}
                                        type="text"
                                        placeholder="Your TG Address For Farming"
                                    />
                                    <button>Save</button>
                                </div>
                            </div>

                            {/* Rewards Section */}
                            <div className="d-flex flex-column flex-md-row align-items-center justify-content-between text-center text-md-start mb-5 mt-5 reward-container">
                                {/* Transaction Card - Moves below Airdrop in mobile */}
                                <div className="w-100">
                                     <TransactionCard2 onStakeClick={handleStakeClick} />
                                    
                                </div>
                            </div>
                           
                              
                           

                            {/* Top gainer */}
                            <div className="d-flex flex-column flex-md-row justify-content-between gap-3 mt-5">
                                {top7DayPerformer?.seven_days?.length > 0 && top7DayPerformer?.thirty_days?.length > 0 && (
                                    <>
                                        <div className="d-flex justify-content-around top-gainer-card w-100">
                                            <p>Top Performer 7 days</p>
                                            <img
                                                src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${top7DayPerformer?.seven_days[0]?.crypto_id}.png`}
                                                alt="Gainer Icon"
                                            />
                                            <p>{top7DayPerformer?.seven_days[0]?.slug}</p>
                                        </div>

                                        <div className="d-flex justify-content-around top-gainer-card w-100">
                                            <p>Top Performer 30 days</p>
                                            <img
                                                src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${top7DayPerformer?.thirty_days[0]?.crypto_id}.png`}
                                                alt="Gainer Icon"
                                            />
                                            <p>{top7DayPerformer?.thirty_days[0]?.slug}</p>
                                        </div>
                                    </>
                                )}
                            </div>

                            {/* My Portfolio */}
                            <div className="section-1" style={{marginRight: mediaQueryVar ? "25px" : ""}}>
                                <div className="profile-headings mt-5">
                                    <h1>MY PORTFOLIOS</h1>
                                </div>
                                <MyPortfolioTable />
                            </div>

                            <Day7SummaryTable />
                            {/* </div> */}

                            {/* Crypto Watchlist */}
                            {/* <div className="section-3 mt-5">
                            <div className="profile-headings mt-5">
                                <h1>CRYPTO WATCHLIST</h1>
                            </div>
                            <div className="add-crypto-watchlist-button d-flex justify-content-center mt-3">
                                <button className="d-flex align-items-center ">
                                    <span>ADD MORE CRYPTOS</span>
                                    <img
                                        src="images/profile_image/account_image/left-arrow-icon.svg"
                                        className="left-arrow-icon"
                                    />
                                </button>
                            </div>
                            <CryptoWatchlist />
                        </div> */}

                            {/* Crypto Watchlist */}
                            <CryptoWatchlist />

                            {/* Portfolio Watchlist */}
                            <MyPortfolioWatchlist />
                        </div>
                    </div>
                </div>
            </div>
            {!mediaQueryVar && (
                <div
                    style={{
                        position: "fixed",
                        bottom: "0",
                        backgroundColor: "white",
                        width: "105%",
                        zIndex: "100",
                        marginLeft: "-10px",
                    }}
                >
                    <BottomNavigation showLabels>
                        <BottomNavigationAction
                            label="Top Portfolios"
                            onClick={() => navigate("/portfolio-gallery")}
                            icon={
                                <img
                                    src={
                                        loc === "/portfolio-gallery"
                                            ? "/images/dashboardS.svg"
                                            : "/images/dashboardU.svg"
                                    }
                                />
                            }
                        />
                        <BottomNavigationAction
                            label="My Portfolios"
                            onClick={() => {
                                navigate(
                                    userData ? "/my-portfolio/detailed-portfolio-analysis" : "/audit-my-portfolio"
                                );
                            }}
                            icon={
                                <img
                                    src={
                                        loc === "/my-portfolio/detailed-portfolio-analysis"
                                            ? "/images/portfolioS.svg"
                                            : "/images/portfolioU.svg"
                                    }
                                />
                            }
                        />
                        <BottomNavigationAction
                            label="Subscription"
                            onClick={() => {
                                navigate("/subscriptions");
                            }}
                            icon={
                                <img
                                    src={loc === "/subscriptions" ? "/images/dollarS.svg" : "/images/dollarU.svg"}
                                    width={24}
                                    height={24}
                                    alt="Icon"
                                    style={{marginBottom: "-3px"}}
                                />
                            }
                        />
                    </BottomNavigation>
                </div>
            )}
        </>
    );
};

export default Account;
